/**
 * Answer text that resumes after a tool result starts a new paragraph.
 * Without the break, the two runs render glued ("…timestamps.We issued…").
 */
export function separateReplyAfterTool(
  existing: string,
  incoming: string
): string {
  if (!incoming || !existing) return incoming;
  const trailing = existing.match(/\n*$/)?.[0].length ?? 0;
  const leading = incoming.match(/^\n*/)?.[0].length ?? 0;
  const missing = Math.max(0, 2 - trailing - leading);
  return `${'\n'.repeat(missing)}${incoming}`;
}
